import {
  ApplicantCode,
  FcFinSimpleGrowProfileAccountsByMcnQuery,
  FcFinSimpleGrowProfileCustomerAccountRelationQuery,
  Fmcc__PhoneType,
} from '@src/__generated__/graphql'
import { PreferenceChannel, PreferencePermission } from '@src/enums/NotificationTypes'

const MOCK_MCN = '9999999'
const JACOB_RAN = 100200
const CLAIRE_RAN = 59847236
const fcProfileAccountsByMcnMock: FcFinSimpleGrowProfileAccountsByMcnQuery = {
  fmcc: {
    account: {
      accountsByMCN: [
        {
          accountNumber: JACOB_RAN,
          applicantType: ApplicantCode.Pr,
          companyBusinessCode: 1,
          vehicleIdentificationNumber: 'H987654321',
          vehicleMake: 'Ford',
          vehicleModel: 'GT',
          vehicleYear: 2019,
          vehicleNickname: 'GTO',
          __typename: 'fc__account__PinnacleAccount',
        },
        {
          accountNumber: CLAIRE_RAN,
          applicantType: ApplicantCode.Co,
          companyBusinessCode: 1,
          vehicleIdentificationNumber: 'C1234567',
          vehicleMake: 'Ford',
          vehicleModel: 'Focus',
          vehicleYear: 2004,
          vehicleNickname: 'Lazer Focus',
          __typename: 'fc__account__PinnacleAccount',
        },
      ],
      __typename: 'fmcc__account__Query',
    },
    __typename: 'fmcc__Query',
  },
  __typename: 'Query',
}
const fcProfileCustomerAccountRelationMock_Jacob: FcFinSimpleGrowProfileCustomerAccountRelationQuery = {
  fmcc: {
    customer: {
      customerAccountRelation: {
        customerProfile: {
          id: 100200,
          firstName: 'Jacob',
          lastName: 'Howard',
          digitalCommunications: [
            {
              text: 'JACOB@FORD.COM',
              __typename: 'fc__customer__DigitalCommunication',
            },
          ],
          billingAddress: {
            addressLine1: '123 Anywhere St',
            addressLine2: 'Apt. 456',
            city: 'MI',
            state: 'Detroit',
            zip: '48203',
            country: 'USA',
            __typename: 'fc__customer__BillingAddress',
          },
          phoneNumbers: [
            {
              phoneNumber: '406726369',
              phoneType: Fmcc__PhoneType.Secondary,
              phoneIDNumber: '18871695',
              __typename: 'fmcc__phoneNumber',
            },
            {
              phoneNumber: '123456789',
              phoneType: Fmcc__PhoneType.Primary,
              phoneIDNumber: '36684214',
              __typename: 'fmcc__phoneNumber',
            },
          ],
          __typename: 'fmcc__customer__CustomerProfile',
        },
        notificationPreferences: {
          customerPreferences: [
            {
              channel: PreferenceChannel.EMAIL,
              permission: true,
              permissionType: PreferencePermission.MARKETING,
              phoneIdNumber: '0',
              __typename: 'fc__customer__Preferences',
            },
          ],
          accountPreferences: [
            {
              preferences: [
                {
                  channel: PreferenceChannel.EMAIL,
                  permission: true,
                  permissionType: PreferencePermission.PAPERLESS_BILLING,
                  phoneIdNumber: '0',
                  __typename: 'fc__customer__Preferences',
                },
                {
                  channel: PreferenceChannel.SMS,
                  permission: true,
                  permissionType: PreferencePermission.ONLINE_STATEMENT_AVAILABILITY,
                  phoneIdNumber: '18871695',
                  __typename: 'fc__customer__Preferences',
                },
              ],
              account: {
                id: 100200,
                __typename: 'fmcc__account__Account',
              },
            },
          ],
        },
        account: {
          id: 100200,
          garagingAddress: {
            addressLine1: '456 OverThere Rd',
            addressLine2: '',
            city: 'MI',
            state: 'Ann Arbor',
            zip: '48108',
            country: 'USA',
            __typename: 'fmcc__account__Address',
          },
          __typename: 'fmcc__account__Account',
        },
        __typename: 'fmcc__customer__CustomerAccountRelation',
      },
      __typename: 'fmcc__customer__Query',
    },
    __typename: 'fmcc__Query',
  },
  __typename: 'Query',
}
const fcProfileCustomerAccountRelationMock_Claire: FcFinSimpleGrowProfileCustomerAccountRelationQuery = {
  fmcc: {
    customer: {
      customerAccountRelation: {
        customerProfile: {
          id: 59847236,
          firstName: 'Claire',
          lastName: 'Watkins',
          digitalCommunications: [
            {
              text: 'CLAIRE@FORD.COM',
              __typename: 'fc__customer__DigitalCommunication',
            },
          ],
          billingAddress: {
            addressLine1: '679 Lane Rd',
            addressLine2: '',
            city: 'Dearborn',
            state: 'MI',
            zip: '48120',
            country: 'USA',
            __typename: 'fc__customer__BillingAddress',
          },
          phoneNumbers: [
            {
              phoneNumber: '194827364',
              phoneType: Fmcc__PhoneType.Secondary,
              phoneIDNumber: '847263403',
              __typename: 'fmcc__phoneNumber',
            },
            {
              phoneNumber: '203847265',
              phoneType: Fmcc__PhoneType.Primary,
              phoneIDNumber: '574638567',
              __typename: 'fmcc__phoneNumber',
            },
          ],
          __typename: 'fmcc__customer__CustomerProfile',
        },
        notificationPreferences: {
          customerPreferences: [
            {
              channel: PreferenceChannel.EMAIL,
              permission: false,
              permissionType: PreferencePermission.MARKETING,
              phoneIdNumber: '0',
              __typename: 'fc__customer__Preferences',
            },
          ],
          accountPreferences: [
            {
              preferences: [
                {
                  channel: PreferenceChannel.SMS,
                  permission: false,
                  permissionType: PreferencePermission.PAYMENT_REMINDER,
                  phoneIdNumber: '847263403',
                  __typename: 'fc__customer__Preferences',
                },
                {
                  channel: PreferenceChannel.EMAIL,
                  permission: false,
                  permissionType: PreferencePermission.PAYMENT_REMINDER,
                  phoneIdNumber: '0',
                  __typename: 'fc__customer__Preferences',
                },
              ],
              account: {
                id: 59847236,
                __typename: 'fmcc__account__Account',
              },
            },
          ],
        },
        account: {
          id: 59847236,
          garagingAddress: {
            addressLine1: '987 Lane Rd',
            addressLine2: '',
            city: 'Dearborn',
            state: 'MI',
            zip: '48120',
            country: 'USA',
            __typename: 'fmcc__account__Address',
          },
          __typename: 'fmcc__account__Account',
        },
        __typename: 'fmcc__customer__CustomerAccountRelation',
      },
      __typename: 'fmcc__customer__Query',
    },
    __typename: 'fmcc__Query',
  },
  __typename: 'Query',
}

export {
  MOCK_MCN,
  JACOB_RAN,
  CLAIRE_RAN,
  fcProfileAccountsByMcnMock,
  fcProfileCustomerAccountRelationMock_Jacob,
  fcProfileCustomerAccountRelationMock_Claire,
}
